import { getBiVideoCardName } from '../bi-selectors/get-bi-video-card-name';
import { get } from 'lodash';
export function createVideoCardsBiLogger(logBi) {
    return {
        logCardClick({ card, biOrigin }) {
            return logBi('widget.videoCards.card.click', {
                cardName: getBiVideoCardName(card),
                origin: biOrigin,
                socialNetwork: get(card, 'network', null),
            });
        },
        logCardCloseButtonClick({ card }) {
            return logBi('widget.videoCards.card.close.click', {
                cardName: getBiVideoCardName(card),
            });
        },
        logAllCardsButtonClick() {
            return logBi('widget.videoCards.allCards.open.click');
        },
        logAllCardsCloseButtonClick() {
            return logBi('widget.videoCards.allCards.close.click');
        },
    };
}
//# sourceMappingURL=create-video-cards-bi-logger.js.map